module.exports = {"310113003":"友谊路街道","310113007":"吴淞街道","310113008":"张庙街道","310113101":"罗店镇","310113102":"大场镇","310113103":"杨行镇","310113104":"月浦镇","310113106":"罗泾镇","310113109":"顾村镇","310113111":"高境镇","310113112":"庙行镇","310113113":"淞南镇","310113501":"宝山城市工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310113.json
// module id = 818
// module chunks = 0